import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KfConfigurationComponent } from './containers/kf-configuration/kf-configuration.component';
import {KfDataEntryRoutingModule} from './kf-data-entry-routing.module';
import {SharedModule} from '../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { KfConfigurationTableComponent } from './components/kf-configuration/kf-configuration-table/kf-configuration-table.component';
import { KfConfigurationEditComponent } from './containers/kf-configuration-edit/kf-configuration-edit.component';
import { KfConfigurationEditStepBarComponent } from './components/kf-configuration/kf-configuration-edit-step-bar/kf-configuration-edit-step-bar.component';
import { KfConfigurationEditTableComponent } from './components/kf-configuration/kf-configuration-edit-table/kf-configuration-edit-table.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { KfConfigurationEditDragDropComponent } from './components/kf-configuration/kf-configuration-edit-drag-drop/kf-configuration-edit-drag-drop.component';
import { KfRegistrationComponent } from './containers/kf-registration/kf-registration.component';
import { KfRegistrationTableComponent } from './components/kf-registration-table/kf-registration-table.component';
import { KfRegistrationFilterComponent } from './components/kf-registration-filter/kf-registration-filter.component';
import { KfRegistrationEditComponent } from './components/kf-registration-edit/kf-registration-edit.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import { KfRegistrationEditTableDifferentiatedComponent } from './components/kf-registration-edit-table-differentiated/kf-registration-edit-table-differentiated.component';
import { KfRegistrationEditTableUndifferentiatedComponent } from './components/kf-registration-edit-table-undifferentiated/kf-registration-edit-table-undifferentiated.component';
import { KfRegistrationEditTableCostDifferentiatedComponent } from './components/kf-registration-edit-table-cost-differentiated/kf-registration-edit-table-cost-differentiated.component';
import { KfRegistrationEditTableCostUndifferentiatedComponent } from './components/kf-registration-edit-table-cost-undifferentiated/kf-registration-edit-table-cost-undifferentiated.component';
import {MdePopoverModule} from '@material-extended/mde';
import { KfConfigurationFilterComponent } from './components/kf-configuration/kf-configuration-filter/kf-configuration-filter.component';
import { KfRegistrationEditTableRecyclingComponent } from './components/kf-registration-edit-table-recycling/kf-registration-edit-table-recycling.component';
import { KfConfigurationSummaryTableComponent } from './components/kf-configuration/kf-configuration-summary-table/kf-configuration-summary-table.component';
import { KfConfigurationMappingComponent } from './containers/kf-configuration-mapping/kf-configuration-mapping.component';



@NgModule({
  declarations: [
    KfConfigurationComponent,
    KfConfigurationTableComponent,
    KfConfigurationEditComponent,
    KfConfigurationEditStepBarComponent,
    KfConfigurationEditTableComponent,
    KfConfigurationEditDragDropComponent,
    KfRegistrationComponent,
    KfRegistrationTableComponent,
    KfRegistrationFilterComponent,
    KfRegistrationEditComponent,
    KfRegistrationEditTableDifferentiatedComponent,
    KfRegistrationEditTableUndifferentiatedComponent,
    KfRegistrationEditTableCostDifferentiatedComponent,
    KfRegistrationEditTableCostUndifferentiatedComponent,
    KfConfigurationFilterComponent,
    KfRegistrationEditTableRecyclingComponent,
    KfConfigurationSummaryTableComponent,
    KfConfigurationMappingComponent
  ],
  imports: [
    CommonModule,
    KfDataEntryRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    DragDropModule,
    FormsModule,
    FlexLayoutModule,
    MdePopoverModule,
  ]
})
export class KfDataEntryModule { }
